import api from '../backAxios';

class LogsParamentosService {
    async geraLogPagamento(dadosParaGerarLog) {
        try{
            const logGerado = await api.post('/logs/pagamentos/', dadosParaGerarLog);

            return logGerado.data;
        }catch(error){
            console.error(error);
        }
    }
}

export default new LogsParamentosService();